import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { BaseResponse } from 'src/types';

interface SubmitOptions<R> {
    apiCall: (payload: any) => Promise<R>;
    codSistemaPrincipal?: number;
    successMessage?: string;
    errorMessage?: string;
    navigateTo?: string | null;
    onSuccess?: (res: R) => void;
}

export const useSubmitOperacion = () => {
    const navigate = useNavigate();

    const submitOperacion = useCallback(async <T, R extends BaseResponse>(
        data: T,
        options: SubmitOptions<R>
    ) => {
        const {
            apiCall,
            codSistemaPrincipal,
            successMessage = 'Operación guardada con éxito',
            errorMessage = 'Error al guardar la operación',
            navigateTo = '/',
            onSuccess,
        } = options;

        const payload = codSistemaPrincipal 
            ? { ...data, codPais: codSistemaPrincipal } 
            : data;

        const processPromise = async () => {
            try {
                const response = await apiCall(payload);
                if (response.tieneError) {
                    throw new Error(response.descripcionError || errorMessage);
                }
                
                return response;
            } catch (error: any) {
                throw new Error(error.message || errorMessage);
            }
        };

        return toast.promise(processPromise(), {
            loading: 'Guardando...',
            success: (res) => {
                if (onSuccess) onSuccess(res);
             
                if (navigateTo) navigate(navigateTo);

                return successMessage;
            },
            error: (err) => err.message,
        }).catch((err) => {console.log(err)});
    }, [navigate]);

    return { submitOperacion };
};
